import { HoneConnectLogoII } from "../../../assets/img";
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaXTwitter,
} from "react-icons/fa6";
import { Link } from "react-router-dom";

const WebsiteFooter = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-honeConnectPurple text-white py-3 sm:py-6">
      <div className="w-11/12 mx-auto">
        <div className="flex flex-wrap justify-between md:gap-y-8">
          {/* Logo Section */}
          <div className="w-full md:w-1/2 lg:w-2/12 order-3 sm:order-1 flex flex-col gap-2 text-center md:text-left items-center md:items-start mb-10 sm:mb-0">
            <img
              src={HoneConnectLogoII}
              alt="Footer Logo"
              className="w-32 mb-2"
            />
            <p className="font-medium text-xs">
              &copy;{new Date().getFullYear()} HoneConnect Ltd | All rights
              reserved.
            </p>
          </div>

          {/* Links Section */}
          <div className="w-full md:w-1/2 lg:w-7/12 order-2 sm:order-2 flex flex-col items-center text-center mb-10 sm:mb-0">
            <ul className="flex flex-wrap justify-center items-center gap-3 sm:gap-10 text-xs font-medium mt-2">
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://dunsregistered.dnb.com/DunsRegisteredProfileAnywhere.aspx?Key1=3190833&PaArea=Email"
                >
                  Dun&Bradstreet Profile
                </a>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
            </ul>

            <ul className="flex flex-wrap justify-center items-center gap-3 sm:gap-10 text-xs font-medium mt-4">
              <li>
                <button
                  type="button"
                  onClick={() => scrollToSection("benefit")}
                >
                  Our Benefits
                </button>
              </li>
              <li>
                <button type="button" onClick={() => scrollToSection("faq")}>
                  FAQs
                </button>
              </li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="w-full md:full lg:w-3/12 order-1 sm:order-3 flex flex-col items-center gap-3 text-sm font-medium mt-8 lg:mt-0 mb-5 sm:mb-0">
            <p className="text-lg winky-sans">Follow Us</p>
            <div className="flex gap-6 text-2xl">
              <a
                href="https://x.com/hone_connect"
                target="_blank"
                rel="noreferrer"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://www.instagram.com/hone.connect?igsh=MXFkajU1eng3dTVucQ=="
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/share/16LWufKfTH/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://www.tiktok.com/@honeconnect?_t=ZM-8vOp6f9epOw&_r=1"
                target="_blank"
                rel="noreferrer"
              >
                <FaTiktok />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
